<template>
  <Modal class="confirmationModal" :class="modal" :title="modalTitle" :isOpen="isOpen" @close="emits('close')" :buttons="[]">
    <template #extra>
      <component :is="modalContents[modal].component" :data="data" @close="emits('close')" @confirm="emits('confirm')" />
    </template>
  </Modal>
</template>

<script setup>
import { computed } from "vue";
import ActivateParticipant from "./partials/ActivateParticipant.vue";
import DesactivateParticipant from "./partials/DesactivateParticipant.vue";
import DeleteParticipant from "./partials/DeleteParticipant.vue";
import MoveParticipant from "./partials/MoveParticipant.vue";
import ArchiveCampaign from "./partials/ArchiveCampaign.vue";
import RestoreCampaign from "./partials/RestoreCampaign.vue";
import DeactivateLink from "./partials/DeactivateLink.vue";

const emits = defineEmits(["close", "confirm"]);
const { t } = useI18n();

const modalContents = {
  activate: {
    component: ActivateParticipant,
  },
  desactivate: {
    component: DesactivateParticipant,
  },
  delete: {
    component: DeleteParticipant,
  },
  move: {
    component: MoveParticipant,
  },
  archive: {
    component: ArchiveCampaign,
  },
  restore: {
    component: RestoreCampaign,
  },
  deactivateLink: {
    component: DeactivateLink,
  },
};

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  data: {
    type: [Array, Object],
    required: true,
  },
  modal: {
    type: String,
    required: true,
  },
});

const modalTitle = computed(() => {
  if (!props.modal) return "";

  switch (props.modal) {
    case "activate":
      return t("app.modals.activateParticipant.title", { count: Array.isArray(props.data) ? props.data.length : 1 });
    case "desactivate":
      return t("app.modals.deactivateParticipant.title", { count: Array.isArray(props.data) ? props.data.length : 1 });
    case "delete":
      return t("app.modals.deleteParticipant.title", { count: Array.isArray(props.data) ? props.data.length : 1 });
    case "move":
      return t("app.modals.moveParticipant.title", { count: Array.isArray(props.data) ? props.data.length : 1 });
    case "archive":
      return t("app.archiveModal.title", { count: Array.isArray(props.data) ? props.data.length : 1 });
    case "restore":
      return t("app.company.archives.restoreCampaign");
    case "deactivateLink":
      return t("app.modals.disableJoinLink.title");
  }
});
</script>
